import { selfAxios } from "../../../../axios/selfAxios.js";
async function postStartMTDSServiceDesk(params) {
  const { data } = await selfAxios.post(`/designordercenter/serviceDesk/startMTDSServiceDesk`, params);
  return data == null ? void 0 : data.data;
}
export { postStartMTDSServiceDesk };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/designordercenter/serviceDesk/startMTDSServiceDesk/post.js